<template>
  <BaseSection class="hidden md:flex items-start">
    <div class="flex-5 mr-8">
      <BaseTitleGroup
        :title="title"
        :subtitle="subtitle"
        class="mb-4"
      />
      <div class="text-xl leading-normal mb-12">
        {{ previewText }}
      </div>
      <tabs @changed="tabChanged">
        <slot />
      </tabs>
    </div>
    <div class="sidebar flex-2 border border-border-color rounded p-6">
      <slot name="right" />
    </div>
  </BaseSection>
</template>

<script>
import BaseSection from '../../components/BaseSection.vue';
import BaseTitleGroup from '../../components/BaseTitleGroup.vue';

export default {
  name: 'ColLayout',
  components: {
    BaseSection,
    BaseTitleGroup,
  },
  props: {
    previewText: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
  },
  methods: {
    tabChanged(selectedTab) {
      analytics.page(selectedTab.tab.id);
    },
  },
};
</script>

<style lang="css" scoped>
.flex-2 {
  flex: 2;
}
.flex-5 {
  flex: 5;
}
</style>
